import { isNaN } from 'lodash';
import { RRule } from 'rrule';
import SourcesHelper from '../helpers/features/SourcesHelper';

const { daysInMonth } = SourcesHelper;

export const formatDate = date => date.toISOString().split('T')[0];

export const getOrdinalLabel = pos => {
  if (pos === -1) return 'last';
  const map = { 1: 'first', 2: 'second', 3: 'third', 4: 'fourth' };
  return map[pos] || `${pos}th`;
};

export const getMonthName = month => {
  const names = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return names[month - 1] ?? '';
};

export const isValidDay = (day, month, frequency) => {
  if (isNaN(day) || day < 1) return false;
  if (frequency === RRule.YEARLY) {
    return day <= daysInMonth[month];
  }
  return day <= 28;
};
